import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useDispatch } from "react-redux";
import { WhirlpoolOffchain } from "@bridgesplit/abf-sdk";

const WHIRLPOOL_TAG = "WhirlpoolList";
export const orcaExternalApi = createApi({
    reducerPath: "orcaExternalApi",
    tagTypes: [WHIRLPOOL_TAG],
    baseQuery: fetchBaseQuery({ baseUrl: "https://api.orca.so/v2/solana" }),
    endpoints: (builder) => ({
        whirlpoolsOffchain: builder.query<{ data: WhirlpoolOffchain[] }, { addresses: string[] }>({
            providesTags: [WHIRLPOOL_TAG],
            query: ({ addresses }) => ({
                url: "/pools",
                method: "GET",
                params: { addresses }
            })
        })
    })
});

export const { useWhirlpoolsOffchainQuery } = orcaExternalApi;

export function useOrcaExternalApi() {
    const dispatch = useDispatch();
    return { resetOrcaExternalApi: () => dispatch(orcaExternalApi.util.invalidateTags([WHIRLPOOL_TAG])) };
}
